// Запись с пересчётом: план считается на текущем состоянии; conflict → дочитать и один раз повторить.
import { data } from '@core/store';
import type { Change, Op } from '@core/store/model';
import { askDeploy, deployConflictsOf, withDeployFix, type DeployChoice } from './deployGuard';

export type Planned = { changes: Change[]; op: Op };

/**
 * Запись с пересчётом; перед ней — сторож даты выхода: если план уводит конец задачи за её прибитую
 * дату, запись не делается, пока человек не решит в окне, что с датой (см. deployGuard). Cancel —
 * ничего не пишется, вся группа остаётся на месте.
 */
export async function applyPlanned(plan: () => Planned): Promise<{ ok: boolean; error?: string; cancelled?: boolean }> {
  const first = plan();
  const conflicts = deployConflictsOf(first.changes);
  let choice: DeployChoice | null = null;
  if (conflicts.length > 0) {
    choice = await askDeploy(conflicts);
    if (!choice) return { ok: true, cancelled: true };
  }
  for (let attempt = 0; attempt < 2; attempt++) {
    const planned = attempt === 0 ? first : plan();
    const { op } = planned;
    const changes = choice ? withDeployFix(planned.changes, deployConflictsOf(planned.changes), choice) : planned.changes;
    if (changes.length === 0) return { ok: true };
    const r = await data.applyChanges(changes, op);
    if (r.ok) return { ok: true };
    if (!r.conflict || attempt === 1) return { ok: false, error: r.error };
    await data.catchUp().catch(() => undefined);
  }
  return { ok: false, error: 'unreachable' };
}
